import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, first, switchMap, tap } from 'rxjs/operators';
import { AccountStoreService } from '../../store/account.store.service';
import { Account } from '../../models/account';
import { IdentityStoreService } from '@modules/identity/store/services/identity-store.service';

@Injectable()
export class AccountUserIdResolver implements Resolve<Account> {
  constructor(private accountStoreService: AccountStoreService, private identityStoreService: IdentityStoreService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Account> {
    return this.identityStoreService.getUserProfile().pipe(
      filter((user) => user !== null),
      switchMap((user) => {
        if (user) {
          return this.accountStoreService.getAccountByUserId(user.sub).pipe(
            tap((account) => {
              if (!account) {
                // this.accountStoreService.fetchAccountByUserId(user.sub);
              }
            })
          );
        } else {
          return of(null);
        }
      }),
      first()
    );
  }
}
